// ─── Formatage d'affichage du chat agents (story 5.5) ────────────────────────
import { format, formatDistanceToNow } from 'date-fns'
import { fr } from 'date-fns/locale'

// `HH:mm` si aujourd'hui, `dd/MM HH:mm` sinon. Chaîne vide si date invalide.
export function formatChatTimestamp(iso: string, now: Date = new Date()): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const sameDay = date.toDateString() === now.toDateString()
  return format(date, sameDay ? 'HH:mm' : 'dd/MM HH:mm', { locale: fr })
}

export function formatConversationDate(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return formatDistanceToNow(date, { addSuffix: true, locale: fr })
}

// Prénom : 1er mot de `name`, sinon partie locale de l'email.
export function getFirstName(name: string | null | undefined, email: string): string {
  const first = name?.trim().split(/\s+/)[0]
  if (first) return first
  return email.split('@')[0] ?? ''
}

// Message d'accueil contextuel (jamais de phrase générique type
// « Comment puis-je vous aider ? »). `activeCampaignCount` null = résumé
// indisponible → on l'omet silencieusement.
export function buildWelcomeText(firstName: string, activeCampaignCount: number | null): string {
  const greeting = firstName ? `Bonjour ${firstName} 👋` : 'Bonjour 👋'
  let summary = ''
  if (activeCampaignCount !== null) {
    summary =
      activeCampaignCount === 0
        ? " Vous n'avez aucune campagne active pour l'instant."
        : ` Vous avez ${activeCampaignCount} campagne${activeCampaignCount > 1 ? 's' : ''} active${activeCampaignCount > 1 ? 's' : ''}.`
  }
  return `${greeting}${summary} Décrivez ce que vous voulez faire : créer une campagne, suivre vos fournisseurs ou générer un template.`
}
